<template>
  <div>
    <div class="topBox">
      <!-- 头部 -->
      <div class="head">
        <img class="img_arrow" src="@/assets/test/return.png" alt @click="goBack()">
        <p class="my_title">发布提问</p>
        <button :disabled="isdisabled" :class="{garybtn:isdisabled == true}" @click="save()">发布</button>
      </div>
      <div class="maxbox">
        <!-- 文字 -->
        <div class="test">
          <div class="inp_box">

            <textarea id="" v-model="testVal" placeholder="发布问题一起互动吧~" class="ipts" name="" cols="30" rows="10" @click="offemil"></textarea>
          <!-- <div class="test" v-html="message_html"></div> -->
          </div>
        </div>
      </div>
      <!-- xiaolian -->
      <div class="smile">
        <img src="@/assets/myicon/smile.png" alt="" @click="showemoji()">
      </div>
      <!-- 图片 -->
      <div class="photo">
        <van-uploader v-model="fileList" upload-icon="plus" style="@uploader-size: 80px;" multiple :max-count="9" :after-read="afterRead" :before-delete="delafterRead" @uploader-size="222" />
      </div>
    </div>

    <!-- 表情 -->
    <div v-show="is_emoji" class="fot_menu">
      <div class="emoji_box">
        <div class="emoji_div">
          <!-- <div v-for="(item,index) in emojiArr" :key="index" class="emoji_text">
                  <img :src="item.key" alt="">
                </div> -->
          <emotion
            v-show="emotionShow"
            ref="emotion"
            class="emotion"
            :height="90"
            @emotion="handleEmotion"
          ></emotion>
        </div>
        <!-- <div class="emoji_send">
            <span class="emoji_btn" @click="send_emoji">发送</span>
              <span class="del_emoji" @click="del_emoji">
              <img src="@/assets/emotion_del.png" alt="">
            </span>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Emotion from '@/components/emotion/index'
import Cookies from 'js-cookie'
import { saveQa } from '@/api/course.js'
import { Toast } from 'vant'
export default {
  components: {
    Emotion
  },
  data() {
    return {
      testVal: '',
      inners: '',
      message_html: '',
      emotionShow: true,
      is_emoji: false,
      fileList: [],
      photoList: [],
      isdisabled: true,
      ipt: '',
      strMap: {},
      isUpload: true,
      biaoList: ['男-惊讶', '男-流泪', '男-害羞', '男-闭嘴', '男-睡', '男-发怒', '男-得意', '男-抓狂', '男-吐', '男-偷笑', '男-困', '男-流汗', '男-咒骂', '男-疑问', '男-嘘', '男-晕', '男-衰', '男-再见', '男-猪头', '男-拥抱', '男-爱心', '男-心碎', '男-强', '男-弱', '男-抠鼻', '男-鼓掌', '男-左哼哼', '男-右哼哼', '男-哈欠', '男-鄙视', '男-委屈', '男-阴险', '男-亲亲', '男-可怜', '男-勾引', '男-NO', '男-OK', '男-爱你', '男-蛋糕', '男-给力', '男-哈哈', '男-大哈哈', '男-蜡烛', '男-礼物', '男-胜利']
    }
  },
  watch: {
    testVal(n, o) {
      if (n != '') {
        this.isdisabled = false
      } else {
        this.isdisabled = true
      }
    }
  },
  mounted() {
    this.getAvator()
  },
  methods: {
    offemil() {
      this.is_emoji = false
    },
    getAvator() {
      var uid = Cookies.get('uid')
      const domain = 'https://avatar.zhulong.com/avatar/'
      let num = uid
      const n = 9
      let len = num.toString().length
      while (len < n) {
        num = '0' + num
        len++
      }
      uid = num
      const dir1 = uid.substr(0, 3)
      const dir2 = uid.substr(3, 2)
      const dir3 = uid.substr(5, 2)
      this.avator = domain + dir1 + '/' + dir2 + '/' + dir3 + '/' + uid.substr(-2) + '_avatar_big.jpg'
      return this.avator
    },
    hideemoji() {
      this.is_emoji = false
    },
    showemoji() {
      if (!this.is_emoji) {
        this.is_emoji = true
        document.activeElement.blur()
      } else {
        this.is_emoji = false
      }
    },
    handleEmotion(i) {
      this.testVal += `${i}`
    },
    getNowFormatDate() {
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      } if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      } var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
                ' ' + date.getHours() + seperator2 + date.getMinutes()
      return currentdate
    },
    save() {
      if (!this.isUpload) {
        Toast('请等待图片上传完成')
        return
      }
      this.isdisabled = true
      this.inners = this.testVal
      var params = {
        lesson_id: this.$route.query.lesson_id,
        content: this.testVal,
        images: this.photoList.toString()
      }
      console.log(params)
      saveQa(params).then(res => {
        if (res.errNo === 0) {
          this.isdisabled = false

          Toast('提交成功')
          sessionStorage.setItem('lessonName', this.$route.query.lesson_name)
          sessionStorage.setItem('lessonId', this.$route.query.lesson_id)
          this.$router.push({
            path: '/qaAll',
            query: {
              active: this.$route.query.active,
              is_buy: this.$route.query.is_buy
            }
          })
        } else {
          this.isdisabled = false
          Toast(res.msg)
        }
      })
    },
    afterRead(e) {
      this.isUpload = false
      if (e instanceof Array) {
        e.forEach((item, index) => {
          const fd = new FormData()
          fd.append('files', item.file)
          axios
            .post('https://f.zhulong.com/uploadZhulongImgForEdit.php', fd)
            .then((res) => {
              this.photoList.push(res.data.url)
              if (e.length - 1 === index) {
                this.isUpload = true
              }
            })
        })
      } else {
        const fd = new FormData()
        fd.append('files', e.file)
        axios
          .post('https://f.zhulong.com/uploadZhulongImgForEdit.php', fd)
          .then((res) => {
            this.photoList.push(res.data.url)
            this.isUpload = true
          })
      }
    },
    delafterRead(e, d) {
      console.log(e, d)
      this.fileList.splice(d.index, 1)
      this.photoList.splice(d.index, 1)
      console.log(this.photoList)
    },
    goBack() {
      this.$router.go(-1)
    }

  }
}
</script>

<style lang="scss" scoped>
button{
  border:0;
}
.topBox{
  padding-bottom: 320px;
}
/deep/ .van-uploader__preview-delete{
  width: 30px;
  height: 30px;
  background-color: #ee2e2e;
  border-radius: 0px 0px 0px 10px;
  border-left: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
/deep/ .van-uploader__preview-delete-icon{
  top: 0;
  right: 0;
}
.photo{
  margin-top: 20px;
}
.fot_menu{
  position: fixed;
  bottom: 0;
  background: #fff;
}
/deep/ .emotion-box{
  width: 750px;
}
.ipts{
  height: 300px;
  width: 95%;
}
.maxbox{
  margin: 90px 0 0 0;
}
.inp_box {
  padding: 10px 0 0 20px;
  .msg_box {
    outline: none;
    width: 100%;
  }
  .edit_box {
    min-height: 200px;
    width: 95%;
  }
}
.fot_menu{
  overflow: hidden;
  overflow-x: scroll;
}
.smile{
  width: 100%;
  height: 50px;
}
.smile img{
  float: right;
  margin: 0 30px 0 0;
  width: 44px;
  height: 44px;
}
.garybtn{
  background: rgba(238,46,46,0.62) !important;
}
/deep/ .van-uploader__preview-image{
    width: 222px;
    height: 222px;
}
/deep/ .van-uploader__upload{
    width: 222px;
    height: 222px;
}
/deep/ .van-uploader__wrapper{
    margin: 0 0 0 25px;
}
.test{
    width: 100%;
    margin: 0px 0 0 0;
    textarea{
        width: 90%;
        font-size: 30px;
        color: #333;
        margin: 10px 0 0 10px;
        border: none;
        resize: none;
        min-height: 200px;
    }
}
.head {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  border-bottom: 1px solid #eee;
  button{
    font-size: 30px;
      margin: 0 20px 0 0;
      width: 120px;
      height: 56px;
      color: #fff;
      border-radius: 8px;
      background: #ee2e2e;
  }
}
.img_arrow {
  width: 45px;
  height: 50px;
  padding-left: 30px;
  padding-top: 9px;
}
.my_title {
    font-weight: 500;
  color: #333;
  font-size: 36px;
  /* font-weight: 600; */
  letter-spacing: 2px;
  padding-left: 60px;
}
</style>
